/**
 * TanStack Query hooks for `igaming-active-player-tracking`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingActivePlayerTrackingQueryKeys,
	type CreateIgamingActivePlayerTrackingBody,
	type ListIgamingActivePlayerTrackingResponse,
	type IgamingActivePlayerTrackingRow,
} from "./api";

export function useIgamingActivePlayerTrackingList(): UseQueryResult<ListIgamingActivePlayerTrackingResponse, Error> {
	return useQuery({
		queryKey: igamingActivePlayerTrackingQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingActivePlayerTrackingCreate(): UseMutationResult<IgamingActivePlayerTrackingRow, Error, CreateIgamingActivePlayerTrackingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingActivePlayerTrackingQueryKeys.all });
		},
	});
}

export function useIgamingActivePlayerTrackingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingActivePlayerTrackingQueryKeys.all });
		},
	});
}
